import client from "./client";

const TransactionService = {};

TransactionService.get = function (data) {
  return client.get(`/transaction`, data);
};
TransactionService.getSummary = function (data) {
  return client.get(`/transaction/summary`, data);
};

TransactionService.create = function (data) {
  return client.post(`/transaction`, data);
};

TransactionService.transfer = function (data) {
  return client.post(`/transaction/transfer`, data);
};

TransactionService.update = function (promoId, data) {
  return client.put(`/transaction/${promoId}`, data);
};

TransactionService.delete = function (promoId) {
  return client.del(`/transaction/${promoId}`);
};

export default TransactionService;
